import { render } from "./TemplateNotebook.vue?vue&type=template&id=a77aebb4&scoped=true"
import script from "./TemplateNotebook.vue?vue&type=script&lang=js"
export * from "./TemplateNotebook.vue?vue&type=script&lang=js"

import "./TemplateNotebook.vue?vue&type=style&index=0&id=a77aebb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77aebb4"]])

export default __exports__